import ArticleLayout from '@/pages/articles/components/ArticleLayout';

export default function TaobaoSpreadsheet() {
  return <ArticleLayout slug="taobao-spreadsheet" />;
}